import React from 'react';
import { Link } from 'react-router-dom';
import { BellIcon, FileBadgeIcon, PawPrintIcon, SmartphoneIcon, TrashIcon, TriangleAlertIcon, VolleyballIcon } from 'lucide-react';
import { quickLinks } from '../data/homepage';
const icons = {
  smartphone: SmartphoneIcon,
  ball: VolleyballIcon,
  alert: TriangleAlertIcon,
  trash: TrashIcon,
  pet: PawPrintIcon,
  permit: FileBadgeIcon,
  bell: BellIcon
};

/**
 * Rangee de services bciti+, posee dans une carte blanche
 * qui mord sur le bas du hero.
 */
export function QuickAccess() {
  return <section aria-labelledby="services-titre" className="relative z-20 bg-ville-mist pb-12" data-id="element-1937" data-mp="2i8rv25bdffom">
      <div className="mx-auto max-w-[1500px] px-5 lg:px-10" data-id="element-1938" data-mp="2n3xqbuqny6pd">
        <div className="-mt-12 rounded-3xl bg-white px-6 py-8 shadow-[0_22px_60px_-24px_rgba(13,79,70,0.45)] lg:px-10" data-id="element-1939" data-mp="2rzwcrcsflen5">
          <h2 id="services-titre" className="sr-only" data-id="element-1940" data-mp="2x1veki8iw3hz">
            Services numeriques
          </h2>

          <ul className="grid grid-cols-2 gap-x-4 gap-y-7 sm:grid-cols-4 lg:grid-cols-7" data-id="element-1941" data-mp="31zdc7ch3awao">
            {quickLinks.map(link => {
            const Icon = icons[link.icon as keyof typeof icons];
            return <li key={link.label} data-id="element-1942" data-mp="3vzhtlhjbzhz0">
                  <Link to={link.to ?? '/'} className="group flex flex-col items-center gap-3 rounded-2xl px-2 py-1 text-center focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-coral" data-id="element-1943" data-mp="3qxai0t2ey3x7">
                    <span className="grid h-16 w-16 place-items-center rounded-full bg-ville-mist text-ville-navy transition-[transform,background-color,color] duration-150 ease-ville group-hover:-translate-y-1 group-hover:bg-ville-coral group-hover:text-white" data-id="element-1944" data-mp="ii8urie7ie39">
                      <Icon className="h-7 w-7" aria-hidden="true" data-id="element-1945" data-mp="9pfa15fzqmi0" />
                    </span>
                    <span className="text-sm font-bold leading-tight text-ville-navy" data-id="element-1946" data-mp="169ea7wg8j4d1">{link.label}</span>
                  </Link>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}